import Form                 from 'components/Form';
import { ApiViolation }     from 'components/MultiStepForm';
import { action }           from 'mobx';
import { computed }         from 'mobx';
import { observable }       from 'mobx';
import React                from 'react';
import { flatten }          from 'tools/flatten';
import { isLoading }        from 'tools/modelxTools';
import notificationApiError from 'tools/notificationApiError';
import { AntErrorFields }   from 'types/AntErrorFields';

export interface IAbstractFormProps {
	attributes?: Record<string, string>;
	onChangeIsSubmitting?: (value: boolean) => void;
	onDisableNavigationItems?: (value: boolean) => void;
	onDisableNextButton?: (value: boolean) => void;
	onDisableSubmitButton?: (value: boolean) => void;
	onFinishFailed?: (params: { errorFields: AntErrorFields }) => void,
}

export abstract class AbstractForm<T> extends React.Component<T & IAbstractFormProps> {
	public formRef = React.createRef<Form>();

	@observable
	private _isSubmitting = false;

	public get form() {
		return this.formRef.current;
	}

	@computed
	public get isSubmitting() {
		return this._isSubmitting;
	}

	public disableNavigationItems(value: boolean) {
		if (this.props.onDisableNavigationItems) {
			this.props.onDisableNavigationItems(value);
		}
	}

	public disableNextButton(value: boolean) {
		if (this.props.onDisableNextButton) {
			this.props.onDisableNextButton(value);
		}
	}

	@action
	public disableSubmitButton(value: boolean) {
		if (this.props.onDisableSubmitButton) {
			this.props.onDisableSubmitButton(value);
		}
	}

	@action
	public setSubmitting(value: boolean) {
		if (this.props.onChangeIsSubmitting) {
			this.props.onChangeIsSubmitting(value);
		}

		this._isSubmitting = value;
	}

	public get isPropsLoading(): boolean {
		return isLoading(this.props);
	}

	public submit(): void {
		this.formRef.current?.submit();
	}

	protected _handleViolations(violations: ApiViolation[]): void {
		const fields = flatten(this.formRef.current?.getFieldsValue());

		const arr = AbstractForm._cleanViolations(violations);

		const errorFormFields = arr
			.filter(v => v.propertyPath)
			.map(v => ({
				errors: [v.message],
				name: v.propertyPath || '',
				value: v.propertyPath ? fields[v.propertyPath] : undefined,
			}));

		this.form?.setFields(errorFormFields);
	}

	protected _handleViolationsFromError(err): void {
		this._handleViolations(err?.connectorError?.response?.data?.violations || []);
	}

	protected _onError(err): void {
		this.setSubmitting(false);

		if (this.props.onFinishFailed) {
			return this.props.onFinishFailed(err);
		}

		notificationApiError(err);

		this._handleViolationsFromError(err);
	}

	private static _cleanViolations(violations: ApiViolation[]): ApiViolation[] {
		return violations.map(violation => {
			const v = { ...violation };

			if (v.propertyPath) {
				v.propertyPath = v.propertyPath.replace(/\[([^\]]+)]/g, '.$1');
			}

			return v;
		});
	}
}

export default AbstractForm;
